import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute,Router } from '@angular/router';
import { UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from '../../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { VersionService } from '../../services/version.service';
import { join } from 'lodash';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'mapfre-auditlib-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  form: UntypedFormGroup;

  domainList: any;

  versionTooltip: any;

  readonly: boolean = false;

  paramRedirect;

  constructor(private authService: AuthService,
    private router: Router,
    @Inject("environment") private environment: any,
    private toasterService: ToastrService,
    private translateService: TranslateService, private route: ActivatedRoute,
    private versionService: VersionService,
    private primeNGConfig: PrimeNGConfig) {
  }

  ngOnInit() {
    let localeUser = navigator && navigator.language ? navigator.language.split("-") : ["es"]
    let locale = localeUser && localeUser.length > 0 ? localeUser[0] : "en"

    // Translate app to locale (user is not logged) and locale is one of app languages
    if (locale.toLowerCase() == "es" || locale.toLowerCase() == "en" || locale.toLowerCase() == "pt" || locale.toLowerCase() == "fr" ||
      locale.toLowerCase() == "it" || locale.toLowerCase() == "tr" || locale.toLowerCase() == "de" || locale.toLowerCase() == "pt_br") {

      this.translateService.currentLang = locale
      this.translateService.reloadLang(locale)
    }
    else {
      // Defaul locale english
      this.translateService.currentLang = "en"
      this.translateService.reloadLang("en")
    }
    this.translateService.get('primeng').subscribe(res => this.primeNGConfig.setTranslation(res));
    this.authService.initMsal()

    // if(this.router.url.includes('redirect')&& this.authService.isLogged()){ // mejora audiweb-enlaces
    //   let str = this.router.url;
    //   let splitted = str.split("?redirect=", 2); //identificamos ?redirect=
    //   let urlRedirect = splitted[1];
    //   urlRedirect = urlRedirect.split('%2F').join('/'); //cambiamos los %2F por / para que enlace correctamente y navegamos a ese url
    //   this.router.navigate([urlRedirect]);
    // }else if (this.authService.isLogged()) {
    //   this.router.navigate(['/pages/dashboard']);
    // }
  }


  @HostListener('keydown.enter', ['$event'])
  onEnterClick() {
    // this.form.markAllAsTouched();
    // if (this.form.valid) {
    //   let { user, password, domain } = this.form.value;
    //   if (!_.includes(user, '@')) {
    //     user = `${user}@${_.get(domain, 'upn').toLowerCase()}`;
    //   }
    //   this.authService.login(user, password).subscribe(res => {
    //     if (res && !_.get(res, 'errorMessage')) {
    //       // Translate app to user language
    //       this.translateService.currentLang = this.authService.getLanguage()
    //       this.translateService.reloadLang(this.authService.getLanguage());

          if(this.router.url.includes('redirect') && this.authService.isLogged()){// mejora audiweb-enlaces
            let str = this.router.url;
            let splitted = str.split("?redirect=", 2);//identificamos redirect
            let urlRedirect = splitted[1];
            urlRedirect = urlRedirect.split('%2F').join('/');//sustituimos
            this.router.navigate([urlRedirect])//se navega
          } else{
            this.router.navigate(["/"])
          }

          this.authService.login()
    //       //iniciar el sessionStorage
    //       sessionStorage.setItem('session', localStorage.getItem(`token-${this.environment.web}`));//si ha hecho login y no es error
    //       sessionStorage.setItem('commentsArray', null)
    //     }
    //   }, (err) => {
    //     if (err.status === STATUS.UNAUTHORIZED) {
    //       this.toasterService.add({ severity: 'error', summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.LOGIN.ERROR.INVALID") })
    //     } else if (err.status === STATUS.INTERNAL_SERVER_ERROR) {
    //       this.toasterService.add({ severity: 'error', summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.LOGIN.ERROR.SERVER") })
    //     } else if (err.status === STATUS.REQUEST_TIMEOUT) {
    //       this.toasterService.add({ severity: "error", summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.ERROR.TIMEOUT") });
    //     } else {
    //       this.toasterService.add({ severity: 'error', summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.LOGIN.ERROR.UNKNOWN") })
    //     }
    //   })
    // }
  }

}
